import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import { actions as switchBusinessActions } from './switchBusiness';
import { history } from '../../utils';

const key = 'PROFILE/GET';
export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetProfile(client, payload) {
  try {
    const response = yield client.post('/user/profile/get');
    const newProfileData = {
      ...response.result,
      user: {
        ...response.result.user,
        businesses: response.result.user.businesses.map((business, i) => ({
          ...business,
          isBusiness: i !== 0,
          isMerchant: business?.sites?.length > 0,
        })),
      },
    };

    const isProv = response?.result?.business?.isProv;
    const isMerchant = response?.result?.business?.sites?.length > 0;
    const businesses = response?.result?.user?.businesses || [];
    if (isProv === false && businesses.length === 1)
      history.push('/create-business');
    // اینجا باید چک کنیم سوییچ کنیم روی اولین بیزینسی ک سایت داره اگر نداشت اولین بیزینس
    else if (isProv === false && businesses.length > 1) {
      const merchantAc = businesses.find(({ sites }) => sites?.length);
      const bi = (merchantAc || businesses[1])._id;
      yield put(switchBusinessActions.load({ bi }));
    }
    yield put(actions.loadSuccess(newProfileData));
    payload.payload &&
      payload.payload.resolve &&
      payload.payload.resolve(newProfileData);
  } catch (e) {
    payload.payload && payload.payload.reject && payload.payload.reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e, undefined, undefined, undefined, true);
  }
}

export default reducer;
